(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["PLP-Faq"]) return;
  try {
    
  $('body').on('click', '.shopify_explorer_faq__question', function() {
      var $this = $(this);
      var $answer = $this.next('.shopify_explorer_faq__answer');

      $('.shopify_explorer_faq__answer').not($answer).slideUp(150).removeClass('active');
      $('.shopify_explorer_faq__question').not($this).removeClass('active');

      $answer.slideToggle(150).toggleClass('active');
      $this.toggleClass('active');
  });

  $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
      $(event.target).find('.shopify_explorer_faq__answer').slideDown(150);
  });

  $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
      $(event.target).find('.shopify_explorer_faq__answer').slideUp(150);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tempfaq"]) return;
  try {
    
(function() {
  $('body').on('click', '.shopify_explorer_faq__question', function() {
    $(this).next('.shopify_explorer_faq__answer').slideToggle(150).toggleClass('active');
    $(this).toggleClass('active');
  });
 
  $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
    $(event.target).find('.shopify_explorer_faq__answer').slideDown(150);
  });
 
  $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
    $(event.target).find('.shopify_explorer_faq__answer').slideUp(150);
  });
}());

  } catch(e) { console.error(e); }
})();
})();
